export default __webpack_public_path__ + "static/media/safety_protection.de3c3e92.png";